import {useState, useEffect} from 'react';

import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import { PhotoAlbum } from 'react-photo-album';

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";



import { useTranslation } from "react-i18next";
import "../../translations/i18n";

const Gallery = ({multimedia}) =>{

    const [index, setIndex] = useState(-1);


    const [galleryObjects, setGalleryObjects] = useState({'slides':[],'photos':[]});
    const [loading, setLoading] = useState(true);

    useEffect (()=>{
        setLoading(true);
        if (multimedia) {
            const loadImage = (url) => {
                return new Promise( (resolve) => {
                    const image = new Image();
                    image.addEventListener('load',() => {
                        resolve(image)
                    })
                    if (url.endsWith('.mp4'))
                        image.src = url.replace(/\.[^/.]+$/, ".jpg")
                    else
                        image.src = url;
                })
  
            };

            const urls = multimedia.split(" ");
            const is_vid = urls.map(url => 
                {
                    if (url.endsWith('.mp4'))
                        return true;
                    else
                        return false;
                })

            Promise.all(urls.map(url => loadImage(url)))
                .then(e => {
                    // console.log(JSON.stringify(e));
                    const p = e.map((i,index) => {
                        return {src: i.src, width: i.width, height: i.height}
                    })
                    const s = e.map((i,index) => {
                        if (! is_vid[index])
                            return {src: i.src}
                        else
                            return { type: "video",
                            poster: i.src,
                            sources: [ {
                                src: urls[index],
                                type: "video/mp4"
                            }
                            ]
                        }
                    })
                    setGalleryObjects({
                        photos: p,
                        slides: s
                    })
                    setLoading(false);
                })
        }
    },[multimedia])

    const { t } = useTranslation();

    return (
        <>
                <h3>{t('gallery.header')} </h3>
                    <PhotoAlbum
                    layout="rows"
                    photos={galleryObjects.photos}
                    targetRowHeight={150}
                    onClick={(event, photo, index) => setIndex(index)}
                    componentsProps={{ imageProps: { loading: "lazy" } }}
                />
                <Lightbox
                    open={index >= 0}
                    index={index}
                    close={() => setIndex(-1)}
                    slides={galleryObjects.slides}
                    plugins={[Video, Thumbnails]}
                    
                />

        </>
    )

}


export default Gallery